import { useState } from "react";

const aiCards = [
  {
    id: 1,
    title: "高风险用户预警",
    icon: "ri-alarm-warning-line",
    color: "text-red-500",
    bg: "bg-red-50",
    border: "border-red-100",
    value: "12户",
    desc: "AI综合评估设备年龄、用气异常、历史整改记录，识别出12户高风险用户，建议优先安排安检",
    tag: "紧急",
    tagColor: "bg-red-100 text-red-600",
    details: ["设备使用超10年：5户", "近期用气量异常：4户", "历史整改未完成：3户"],
  },
  {
    id: 2,
    title: "安检效率分析",
    icon: "ri-bar-chart-line",
    color: "text-teal-500",
    bg: "bg-teal-50",
    border: "border-teal-100",
    value: "87.3%",
    desc: "本月安检完成率87.3%，较上月提升5.2%。AI分析显示周二、周四安检效率最高，建议集中排期",
    tag: "良好",
    tagColor: "bg-teal-100 text-teal-600",
    details: ["平均安检时长：28分钟", "一次通过率：91.2%", "整改完成率：78.5%"],
  },
  {
    id: 3,
    title: "问题类型分布",
    icon: "ri-pie-chart-line",
    color: "text-amber-500",
    bg: "bg-amber-50",
    border: "border-amber-100",
    value: "156项",
    desc: "本季度共发现安全隐患156项，AI分析主要集中在软管老化（38%）和阀门密封（27%）两类问题",
    tag: "需关注",
    tagColor: "bg-amber-100 text-amber-600",
    details: ["软管老化：59项", "阀门密封：42项", "设备腐蚀：31项", "其他：24项"],
  },
  {
    id: 4,
    title: "安检预测排期",
    icon: "ri-calendar-check-line",
    color: "text-orange-500",
    bg: "bg-orange-50",
    border: "border-orange-100",
    value: "234户",
    desc: "AI预测未来30天内需完成安检234户，建议每日安排8-10户，可在计划周期内全部完成",
    tag: "待安排",
    tagColor: "bg-orange-100 text-orange-600",
    details: ["本周到期：45户", "下周到期：67户", "月底到期：122户"],
  },
];

export default function SafetyAICards() {
  const [expanded, setExpanded] = useState<number | null>(null);

  return (
    <div className="bg-gradient-to-r from-[#0f1729] to-[#1a2540] rounded-xl p-4 border border-white/10">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-6 h-6 flex items-center justify-center rounded-lg bg-[#E8531A]/20">
          <i className="ri-brain-line text-[#E8531A] text-sm"></i>
        </div>
        <span className="text-white text-sm font-semibold">AI 安检智能分析</span>
        <span className="flex items-center gap-1 text-xs text-green-400 bg-green-400/10 px-2 py-0.5 rounded-full">
          <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse inline-block"></span>
          实时分析
        </span>
      </div>
      <div className="grid grid-cols-4 gap-3">
        {aiCards.map(card => (
          <div
            key={card.id}
            className={`${card.bg} ${card.border} border rounded-xl p-3 cursor-pointer transition-all ${expanded === card.id ? "ring-2 ring-[#E8531A]/30" : ""}`}
            onClick={() => setExpanded(expanded === card.id ? null : card.id)}
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-1.5">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${card.icon} ${card.color} text-sm`}></i>
                </div>
                <span className="text-xs font-semibold text-gray-800">{card.title}</span>
              </div>
              <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${card.tagColor}`}>{card.tag}</span>
            </div>
            <div className={`text-2xl font-bold ${card.color} mb-1`}>{card.value}</div>
            <p className="text-xs text-gray-600 leading-relaxed">{card.desc}</p>
            {expanded === card.id && (
              <div className="mt-2 pt-2 border-t border-gray-200 space-y-1">
                {card.details.map((d, i) => (
                  <div key={i} className="flex items-center gap-1.5 text-xs text-gray-600">
                    <div className={`w-1.5 h-1.5 rounded-full ${card.color.replace("text-", "bg-")}`}></div>
                    {d}
                  </div>
                ))}
              </div>
            )}
            <div className="mt-2 text-xs text-gray-400 flex items-center gap-1">
              <i className={expanded === card.id ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
              {expanded === card.id ? "收起" : "展开详情"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
